import { useRef } from 'react';

import { useInViewport } from './use-in-viewport';
import { useScrollIdle } from './use-scroll-idle';

interface Options {
  location?: boolean;
  locationDeferred?: boolean;
  parentId?: string;
}

export function useDeferredBreadcrumb({
  location,
  locationDeferred = false,
  parentId = ''
}: Options) {
  const ref = useRef<HTMLDivElement>(null);
  const isScrollIdle = useScrollIdle();
  const isInViewport = useInViewport(ref, {
    rootMargin: '100px',
    disabled: !locationDeferred
  });

  const hasParent = !!parentId;
  const immediateEnabled = !!location && hasParent;

  if (!locationDeferred) {
    return { ref, enabled: immediateEnabled };
  }

  return {
    ref,
    enabled: immediateEnabled && isInViewport && isScrollIdle
  };
}
